
import ShoppingBagIcon from '../../_globals/vectors/ShoppingBagIcon.vue';
import AddIcon from '../../_globals/vectors/AddIcon.vue';
import ArrowDownIcon from '../../_globals/vectors/ArrowDownIcon.vue';
import ArrowLeftIcon from '../../_globals/vectors/ArrowLeftIcon.vue';
import ArrowRightIcon from '../../_globals/vectors/ArrowRightIcon.vue';
import ArrowUpIcon from '../../_globals/vectors/ArrowUpIcon.vue';
import BagIcon from '../../_globals/vectors/BagIcon.vue';
import BellFilledIcon from '../../_globals/vectors/BellFilledIcon.vue';
import BellIcon from '../../_globals/vectors/BellIcon.vue';
import BurgerMenuIcon from '../../_globals/vectors/BurgerMenuIcon.vue';
import CalendarIcon from '../../_globals/vectors/CalendarIcon.vue';
import Carat from '../../_globals/vectors/Carat.vue';
import CheckIcon from '../../_globals/vectors/CheckIcon.vue';
import ChevronDownIcon from '../../_globals/vectors/ChevronDownIcon.vue';
import ChevronLeftIcon from '../../_globals/vectors/ChevronLeftIcon.vue';
import ChevronRightIcon from '../../_globals/vectors/ChevronRightIcon.vue';
import ChevronUpIcon from '../../_globals/vectors/ChevronUpIcon.vue';
import ClockIcon from '../../_globals/vectors/ClockIcon.vue';
import CloseIcon from '../../_globals/vectors/CloseIcon.vue';
import CouponIcon from '../../_globals/vectors/CouponIcon.vue';
import CrossIcon from '../../_globals/vectors/CrossIcon.vue';
import CurbsideIcon from '../../_globals/vectors/CurbsideIcon.vue';
import DeliveryIcon from '../../_globals/vectors/DeliveryIcon.vue';
import DirectionsIcon from '../../_globals/vectors/DirectionsIcon.vue';
import EyeIcon from '../../_globals/vectors/EyeIcon.vue';
import EditIcon from '../../_globals/vectors/EditIcon.vue';
import ExclamationIcon from '../../_globals/vectors/ExclamationIcon.vue';
import FilterIcon from '../../_globals/vectors/FilterIcon.vue';
import ForkIcon from '../../_globals/vectors/ForkIcon.vue';
import GiftCardIcon from '../../_globals/vectors/GiftCardIcon.vue';
import HeartFilledIcon from '../../_globals/vectors/HeartFilledIcon.vue';
import HeartIcon from '../../_globals/vectors/HeartIcon.vue';
import HomeIcon from '../../_globals/vectors/HomeIcon.vue';
import InfoIcon from '../../_globals/vectors/InfoIcon.vue';
import LocationFilledIcon from '../../_globals/vectors/LocationFilledIcon.vue';
import ShowIcon from '../../_globals/vectors/ShowIcon.vue';
import HideIcon from '../../_globals/vectors/HideIcon.vue';
import LocationIcon from '../../_globals/vectors/LocationIcon.vue';
import LocationsFilledIcon from '../../_globals/vectors/LocationsFilledIcon.vue';
import LogOutIcon from '../../_globals/vectors/LogOutIcon.vue';
import LogoAmex from '../../_globals/vectors/LogoAmex.vue';
import LogoDiscover from '../../_globals/vectors/LogoDiscover.vue';
import LogoGiftCard from '../../_globals/vectors/LogoGiftCard.vue';
import LogoMasterCard from '../../_globals/vectors/LogoMasterCard.vue';
import LogoVisa from '../../_globals/vectors/LogoVisa.vue';
import MinusIcon from '../../_globals/vectors/MinusIcon.vue';
import NavigationFilledIcon from '../../_globals/vectors/NavigationFilledIcon.vue';
import NavigationIcon from '../../_globals/vectors/NavigationIcon.vue';
import NumeralIcon from '../../_globals/vectors/NumeralIcon.vue';
import OrderIcon from '../../_globals/vectors/OrderIcon.vue';
import OffersIcon from '../../_globals/vectors/OffersIcon.vue';
import PackCartIcon from '../../_globals/vectors/PackCartIcon.vue';
import PaymentsIcon from '../../_globals/vectors/PaymentsIcon.vue';
import PhoneIcon from '../../_globals/vectors/PhoneIcon.vue';
import PickupIcon from '../../_globals/vectors/PickupIcon.vue';
import PizzaLFilledIcon from '../../_globals/vectors/PizzaLFilledIcon.vue';
import PizzaLIcon from '../../_globals/vectors/PizzaLIcon.vue';
import PizzaRFilledIcon from '../../_globals/vectors/PizzaRFilledIcon.vue';
import PizzaRIcon from '../../_globals/vectors/PizzaRIcon.vue';
import PizzaWFilledIcon from '../../_globals/vectors/PizzaWFilledIcon.vue';
import PizzaWIcon from '../../_globals/vectors/PizzaWIcon.vue';
import PlusCircle from '../../_globals/vectors/PlusCircle.vue';
import PlusIcon from '../../_globals/vectors/PlusIcon.vue';
import ProfileIcon from '../../_globals/vectors/ProfileIcon.vue';
import ReservationIcon from '../../_globals/vectors/ReservationIcon.vue';
import RewardsIcon from '../../_globals/vectors/RewardsIcon.vue';
import SearchIcon from '../../_globals/vectors/SearchIcon.vue';
import ShoppingCartIcon from '../../_globals/vectors/ShoppingCartIcon.vue';
import StoreIcon from '../../_globals/vectors/StoreIcon.vue';
import TrashIcon from '../../_globals/vectors/TrashIcon.vue';
import VerticalDotsIcon from '../../_globals/vectors/VerticalDotsIcon.vue';
import WalletIcon from '../../_globals/vectors/WalletIcon.vue';
import AppleIcon from '../../_globals/vectors/AppleIcon.vue';
import FacebookIcon from '../../_globals/vectors/FacebookIcon.vue';
import FacebookFilledIcon from '../../_globals/vectors/FacebookFilledIcon.vue';
import GoogleIcon from '../../_globals/vectors/GoogleIcon.vue';
import InstagramIcon from '../../_globals/vectors/InstagramIcon.vue';
import TikTokIcon from '../../_globals/vectors/TikTokIcon.vue';
import TwitterIcon from '../../_globals/vectors/TwitterIcon.vue';
import TwitterXIcon from '../../_globals/vectors/TwitterXIcon.vue';
import AwardIcon from '../../_globals/vectors/AwardIcon.vue';
import ContainDairyIcon from '../../_globals/vectors/ContainDairyIcon.vue';
import ContainEggIcon from '../../_globals/vectors/ContainEggIcon.vue';
import ContainEggsIcon from '../../_globals/vectors/ContainEggsIcon.vue';
import ContainFishIcon from '../../_globals/vectors/ContainFishIcon.vue';
import ContainGlutenIcon from '../../_globals/vectors/ContainGlutenIcon.vue';
import ContainMilkIcon from '../../_globals/vectors/ContainMilkIcon.vue';
import ContainPeanutIcon from '../../_globals/vectors/ContainPeanutIcon.vue';
import ContainSesameIcon from '../../_globals/vectors/ContainSesameIcon.vue';
import ContainShellfishIcon from '../../_globals/vectors/ContainShellfishIcon.vue';
import ContainSoyIcon from '../../_globals/vectors/ContainSoyIcon.vue';
import ContainVeganIcon from '../../_globals/vectors/ContainVeganIcon.vue';
import ContainWalnutsIcon from '../../_globals/vectors/ContainWalnutsIcon.vue';
import ContainNutsIcon from '../../_globals/vectors/ContainNutsIcon.vue';
import ContainCashewsIcon from '../../_globals/vectors/ContainCashewsIcon.vue';
import ContainWheatIcon from '../../_globals/vectors/ContainWheatIcon.vue';
import ContainCashewIcon from '../../_globals/vectors/ContainCashewIcon.vue';
import SettingsIcon from '../../_globals/vectors/SettingsIcon.vue';

// Flying Pie
import FlyingPieTrophyIcon from '../../_globals/vectors/FlyingPie/Trophy.vue'

// Costa Vida
import CostaVidaCartIcon from '../../_globals/vectors/CostaVida/Cart.vue'

// Lees
import CateringIcon from '../../_globals/vectors/CateringIcon.vue';

export default {
  name: 'Icon',
  props:{
    name: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    ariaHidden: {
      type: String,
      default: 'true',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: 'img',
    },
  },
  components: {
    ShoppingBagIcon,
    AddIcon,
    ArrowDownIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowUpIcon,
    BagIcon,
    BellFilledIcon,
    BellIcon,
    BurgerMenuIcon,
    CalendarIcon,
    Carat,
    CheckIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    ClockIcon,
    CloseIcon,
    CouponIcon,
    CrossIcon,
    CurbsideIcon,
    DeliveryIcon,
    DirectionsIcon,
    EditIcon,
    EyeIcon,
    ExclamationIcon,
    FilterIcon,
    ForkIcon,
    GiftCardIcon,
    HeartFilledIcon,
    HeartIcon,
    HomeIcon,
    InfoIcon,
    LocationFilledIcon,
    LocationIcon,
    LocationsFilledIcon,
    LogOutIcon,
    LogoAmex,
    LogoDiscover,
    LogoGiftCard,
    LogoMasterCard,
    LogoVisa,
    MinusIcon,
    NavigationFilledIcon,
    NavigationIcon,
    NumeralIcon,
    OrderIcon,
    OffersIcon,
    PackCartIcon,
    PaymentsIcon,
    PhoneIcon,
    PickupIcon,
    PizzaLFilledIcon,
    PizzaLIcon,
    PizzaRFilledIcon,
    PizzaRIcon,
    PizzaWFilledIcon,
    PizzaWIcon,
    PlusCircle,
    PlusIcon,
    ProfileIcon,
    ReservationIcon,
    RewardsIcon,
    SearchIcon,
    ShoppingCartIcon,
    StoreIcon,
    TrashIcon,
    FlyingPieTrophyIcon,
    VerticalDotsIcon,
    WalletIcon,
    CostaVidaCartIcon,
    AppleIcon,
    FacebookIcon,
    FacebookFilledIcon,
    GoogleIcon,
    InstagramIcon,
    TikTokIcon,
    TwitterIcon,
    TwitterXIcon,
    AwardIcon,
    CateringIcon,
    ShowIcon,
    HideIcon,
    ContainDairyIcon,
    ContainEggIcon,
    ContainEggsIcon,
    ContainFishIcon,
    ContainGlutenIcon,
    ContainMilkIcon,
    ContainPeanutIcon,
    ContainSesameIcon,
    ContainShellfishIcon,
    ContainSoyIcon,
    ContainVeganIcon,
    ContainWalnutsIcon,
    ContainNutsIcon,
    ContainCashewsIcon,
    ContainWheatIcon,
    ContainCashewIcon,
    SettingsIcon,
  }
}
